<template>
    <div class="newbutton">
        <div style="padding: 10px 18px">
            输入药名查询:
            <el-input style="width: 150px" v-model="medicineName" placeholder="请输入药品名" clearable></el-input>
            <el-button type="success" class="el-icon-search" @click="onSubmit()"></el-button>

        </div>
        <template>
            <el-table :data="tableData" stripe style="width: 98%;margin-left: 18px" :cell-style="cellStyle"
                      :header-cell-style="tableHeaderColor">
                <el-table-column prop="value" label="药品名称" width="400px"></el-table-column>
                <el-table-column prop="manufacturer" label="产地"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="number" label="库存数量"></el-table-column>

                <el-table-column prop="actualNumber" label="实际数量">
                    <template slot-scope="{row}">
                        <el-input style="width: 80px" v-model="row.actualNumber"
                                  @change="numberChange(row, $event)"></el-input>
                    </template>
                </el-table-column>

                <el-table-column label="盘盈盘亏">
                    <template slot-scope="{row}">
                        {{row.diffNumber}}
                    </template>
                </el-table-column>
            </el-table>
        </template>

        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size=this.Size
                    layout="total,prev, pager, next, jumper"
                    :total=this.total>
            </el-pagination>
        </div>
        <div style="margin: 30px 10px ;padding-bottom: 20px">
            <el-button @click="rvation()" type="primary">保存</el-button>
            <router-link to="./checkStock">
              <el-button :plain="true" type="info">取消</el-button>
            </router-link>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        total: 0,
        Current: 1,
        Size: 10,
        currentPage: 1,
        restaurants: [],
        medicineName: '',
        state: '',
        timeout: null,
        medicine: [],
        tableData: [],
        currentPage3: 5,
        row: [],
        ches:[],
        changeRow:{}
      };
    },
    mounted: function () {
      this.getinfo();
    },
    methods: {
      getinfo: function () {
        let medicineQuery = {
          "medicineName": this.medicineName,
          "medicineStatus": false,
          "warning": false
        }
        this.$axios({
          url: '/api/medicines/pageNumber/' + this.Current + '/size/' + this.Size,
          method: 'POST',
          data: medicineQuery
        }).then(res => {
          let sessionData = JSON.parse(sessionStorage.getItem("checkDetails"));
          this.total = res.data.data.totalElements;
          let Data = res.data.data.content;
          for (let k = 0; k < Data.length; k++) {
            Data[k].diffNumber = 0;
            if (sessionData && sessionData[Data[k].id] ) {
              Data[k].actualNumber = sessionData[Data[k].id].actualNumber
              Data[k].diffNumber = sessionData[Data[k].id].diffNumber
            } else {
              Data[k].actualNumber = '';
              Data[k].diffNumber = 0;
            }
          }
          this.tableData = Data;
        }).catch(err => {
          console.log(err.data)
        })
      },
      cellStyle({row, column, rowIndex, columnIndex}) {
        if (columnIndex == 5) {
          if (row.diffNumber > 0) {
            return 'color:blue'
          } else if (row.diffNumber < 0) {
            return 'color:red'
          }
        }
      },
      onSubmit: function () {
        this.getinfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.Size = val;
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.Current = val;
        this.getinfo();
      },
      //获取改变的一行数据
      numberChange: function (row, val) {
        // console.log(row);
        let id = row.id;
        // 更新当前行
        if (val === '') {
          row.actualNumber = '';
          row.diffNumber = 0;}
        else {
          row.actualNumber = Number(val);
          row.diffNumber = Number(val) - row.number;}
        // 更新后续提交的变更字典
        if (val === '') {
          delete this.changeRow[id]; }
        else {
          this.changeRow[id] = {
            "actualNumber": row.actualNumber,
            "diffNumber": row.diffNumber,
            "medicineId": id
          };
        }
        let checkDetails = JSON.stringify(this.changeRow);
        sessionStorage.setItem("checkDetails",checkDetails);
      },

      //保存按钮
      rvation: function () {
        let checkDetails = JSON.parse(sessionStorage.getItem("checkDetails"));
        this.$axios({
          url: '/api/medicine/check',
          method: 'POST',
          data: {checkDetails: Object.values(checkDetails)}
        }).then(res => {
          this.$message({
            type: 'success',
            message: '保存成功'
          });
          sessionStorage.removeItem("checkDetails");
          this.$router.push({path: './checkStock'})
        }).catch(err => {
          console.log(err);
        })
      },
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return 'background-color:rgb(198, 226, 255);color: black;'
        }
      },
    }

  }
</script>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .nav {
        width: 100%;
        background: #f1f1f1;
    }

    .marginLeft {
        margin-top: 10px;
        padding-top: 10px;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }
</style>



// WEBPACK FOOTER //
// newbutton.vue?7bda8908